import { Heart, Leaf, Sparkles } from 'lucide-react';

export const mockServices = [
  {
    icon: <Heart className="w-8 h-8" />,
    title: 'Massage Bien-être',
    description: 'Massages personnalisés à Angoulême pour soulager les tensions, réduire le stress et restaurer votre énergie vitale. Laura Body, masseuse bien-être à Angoulême.',
    benefits: [
      'Réduction du stress et de l\'anxiété',
      'Amélioration de la circulation sanguine',
      'Soulagement des douleurs musculaires',
      'Relaxation profonde du corps'
    ]
  },
  {
    icon: <Sparkles className="w-8 h-8" />,
    title: 'Réflexologie',
    description: 'Réflexologie plantaire à Angoulême : technique ancestrale stimulant les zones réflexes du pied pour rétablir l\'équilibre naturel du corps. Votre réflexologue à Angoulême.',
    benefits: [
      'Stimulation des capacités d\'auto-guérison',
      'Amélioration du système immunitaire',
      'Réduction des tensions nerveuses',
      'Harmonisation des fonctions vitales'
    ]
  },
  {
    icon: <Leaf className="w-8 h-8" />,
    title: 'Naturopathie',
    description: 'Consultations en naturopathie à Angoulême : votre naturopathe à Angoulême vous propose une approche naturelle et holistique pour optimiser votre santé.',
    benefits: [
      'Bilan de santé personnalisé',
      'Conseils nutritionnels adaptés',
      'Phytothérapie et aromathérapie',
      'Accompagnement holistique'
    ]
  }
];

export const mockTarifs = [
  {
    name: 'Consultation Naturopathique',
    price: '70',
    duration: '1h30',
    description: 'Bilan complet personnalisé',
    popular: false,
    includes: [
      'Consultation naturopathie 1h30',
      'Bilan bien-être',
      'Conseils personnalisés'
    ]
  },
  {
    name: 'Séance Réflexologie Plantaire',
    price: '65',
    duration: '01h00',
    description: 'Détente et rééquilibrage énergétique',
    popular: true,
    includes: [
      'Réflexologie plantaire 45 min',
      'Stimulation des zones réflexes',
      'Moment de relaxation'
    ]
  },
  {
    name: 'Massage Shirotchampi',
    price: '70',
    duration: '1 heure',
    description: 'Massage ayurvédique du cuir chevelu, visage, cou et épaules',
    popular: false,
    includes: [
      'Approche globale corps-esprit',
      'Effets apaisants sur le système nerveux',
      'Action relaxante sur le mental',
      'Bienfaits pour les cheveux et le cuir chevelu'
    ]
  },
  {
    name: 'Massage Rose Équilibre',
    price: '80',
    duration: '1h15',
    description: 'Soin réservé aux femmes – Massage holistique corps et esprit',
    popular: false,
    includes: [
      'Huile essentielle de Rose de Damas',
      'Quartz rose',
      'Lâcher-prise et sérénité',
      'Rééquilibrage corps-esprit'
    ]
  },
  {
    name: 'Pack Cutané',
    price: '490',
    duration: 'forfait',
    description: 'Accompagnement complet pour soulager vos troubles cutanés',
    popular: false,
    oldPrice: '540',
    includes: [
      '4 séances de naturopathie',
      '4 séances de réflexologie',
      'Accompagnement global et personnalisé',
      'Combinaison naturopathie + réflexologie'
    ]
  }
];

export const mockTestimonials = [
  {
    name: 'Jeanine Bonnet',
    service: 'Massage Bien-être',
    rating: 5,
    text: 'Mon expérience de massage était fantastique. Étant soumise à un stress particulier, le massage m\'a permis de réellement déconnecter et d\'oublier la pression. Laura est douce, à l\'écoute et bienveillante, et cela est propice à la détente au cours du massage. Merci à elle pour son professionnalisme et sa gentillesse. Je recommande à 1000% cette expérience hors du temps !'
  },
  {
    name: 'Chloé Leroy',
    service: 'Massage Bien-être',
    rating: 5,
    text: 'Laura est une professionnelle incroyable. Douce et bienveillante, elle met tout de suite en confiance. Ses massages sont profondément bénéfiques et me transportent à chaque séance. Je la recommande à 100%.'
  },
  {
    name: 'Laurent Dubois',
    service: 'Réflexologie',
    rating: 5,
    text: 'Après plusieurs séances de réflexologie, j\'ai vu une nette amélioration de mon sommeil et de mon niveau d\'énergie. Je recommande vivement!'
  },
  {
    name: 'Marie Lefebvre',
    service: 'Naturopathie',
    rating: 5,
    text: 'Les conseils en naturopathie ont transformé ma vie. Une approche naturelle et efficace qui respecte vraiment le corps.'
  },
  {
    name: 'Thomas Bernard',
    service: 'Massage Bien-être',
    rating: 5,
    text: 'Un moment de pure détente dans un cadre magnifique. Les produits naturels utilisés sentent divinement bon!'
  },
  {
    name: 'Zoé Barcouzareaud',
    service: 'Massage Bien-être',
    rating: 5,
    text: 'Laura est très douce et à l\'écoute. J\'ai passé un très bon moment qui m\'a vraiment fait du bien. Merci à toi !'
  }
];

export const mockGallery = [
  { 
    url: 'https://customer-assets.emergentagent.com/job_nature-health-2/artifacts/xt7fxt5g_IMG_9574.JPG',
    alt: 'Cabinet de bien-être Laura Body - Vue d\'ensemble' 
  },
  { 
    url: 'https://customer-assets.emergentagent.com/job_nature-health-2/artifacts/kxsrgzcg_2276132535598029857.JPG',
    alt: 'Espace détente et bien-être' 
  },
  { 
    url: 'https://customer-assets.emergentagent.com/job_nature-health-2/artifacts/9m8e6ugu_tdm.jpg',
    alt: 'Salle de massage avec table professionnelle' 
  },
  { 
    url: 'https://customer-assets.emergentagent.com/job_nature-health-2/artifacts/w51v3mau_tdm2.jpg',
    alt: 'Espace de massage zen avec poutres apparentes' 
  },
  { 
    url: 'https://customer-assets.emergentagent.com/job_nature-health-2/artifacts/i0a7zo1v_IMG_1965.JPG',
    alt: 'Espace de consultation avec table de massage' 
  },
  { 
    url: 'https://customer-assets.emergentagent.com/job_nature-health-2/artifacts/idfoeeg8_IMG_1966.JPG',
    alt: 'Salle de soins avec mur vert apaisant' 
  }
];